import { render, staticRenderFns } from "./openMoreCase.vue?vue&type=template&id=2d117eec&scoped=true&"
import script from "./openMoreCase.vue?vue&type=script&lang=js&"
export * from "./openMoreCase.vue?vue&type=script&lang=js&"
import style0 from "./openMoreCase.vue?vue&type=style&index=0&id=2d117eec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d117eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d117eec')) {
      api.createRecord('2d117eec', component.options)
    } else {
      api.reload('2d117eec', component.options)
    }
    module.hot.accept("./openMoreCase.vue?vue&type=template&id=2d117eec&scoped=true&", function () {
      api.rerender('2d117eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/components/openMoreCase.vue"
export default component.exports